import PostPageView from "../../components/community/post_pageview";

const UserPostsScreen = () => {
    return <PostPageView isAdmin={false} isPost={true} />
}

export default UserPostsScreen;